const r = {
  "cdr-label-wrapper": "cdr-label-wrapper_15-1-0",
  "cdr-label-wrapper__container": "cdr-label-wrapper__container_15-1-0",
  "cdr-label-wrapper--primary": "cdr-label-wrapper--primary_15-1-0",
  "cdr-label-wrapper--secondary": "cdr-label-wrapper--secondary_15-1-0",
  "cdr-label-wrapper--disabled": "cdr-label-wrapper--disabled_15-1-0",
  "cdr-label-wrapper__figure": "cdr-label-wrapper__figure_15-1-0",
  "cdr-label-wrapper__content": "cdr-label-wrapper__content_15-1-0",
  "cdr-label-wrapper--hide-figure": "cdr-label-wrapper--hide-figure_15-1-0",
  "cdr-checkbox__svg-box": "cdr-checkbox__svg-box_15-1-0",
  "cdr-label-wrapper--small": "cdr-label-wrapper--small_15-1-0",
  "cdr-label-wrapper--medium": "cdr-label-wrapper--medium_15-1-0",
  "cdr-label-wrapper--large": "cdr-label-wrapper--large_15-1-0",
  "cdr-checkbox__checkbox-box": "cdr-checkbox__checkbox-box_15-1-0",
  "cdr-label-wrapper--small@xs": "cdr-label-wrapper--small@xs_15-1-0",
  "cdr-label-wrapper--medium@xs": "cdr-label-wrapper--medium@xs_15-1-0",
  "cdr-label-wrapper--large@xs": "cdr-label-wrapper--large@xs_15-1-0",
  "cdr-label-wrapper--small@sm": "cdr-label-wrapper--small@sm_15-1-0",
  "cdr-label-wrapper--medium@sm": "cdr-label-wrapper--medium@sm_15-1-0",
  "cdr-label-wrapper--large@sm": "cdr-label-wrapper--large@sm_15-1-0",
  "cdr-label-wrapper--small@md": "cdr-label-wrapper--small@md_15-1-0",
  "cdr-label-wrapper--medium@md": "cdr-label-wrapper--medium@md_15-1-0",
  "cdr-label-wrapper--large@md": "cdr-label-wrapper--large@md_15-1-0",
  "cdr-label-wrapper--small@lg": "cdr-label-wrapper--small@lg_15-1-0",
  "cdr-label-wrapper--medium@lg": "cdr-label-wrapper--medium@lg_15-1-0",
  "cdr-label-wrapper--large@lg": "cdr-label-wrapper--large@lg_15-1-0"
};
export {
  r as default
};
